import React from "react";
import { useLocation, Switch, Redirect } from "react-router-dom";
import { Container } from "reactstrap";
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import AdminFooter from "components/Footers/AdminFooter.js";
import adminRoutes from "routes/adminRoutes.js";
import AddExamination from "views/examples/AddExamination";
import AdminRoute from "routes/AdminRoute";
import ChangePassword from "views/examples/ChangePassword";
import EditUser from "views/examples/EditUser";
import AdminSidebar from "components/Sidebar/AdminSidebar";
const Admin = (props) => {
  const mainContent = React.useRef(null);
  const location = useLocation();

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContent.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/admin") {
        return (
          <AdminRoute
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  const getBrandText = (path) => {
    for (let i = 0; i < adminRoutes.length; i++) {
      if (
        props.location.pathname.indexOf(adminRoutes[i].layout + adminRoutes[i].path) !==
        -1
      ) {
        return adminRoutes[i].name;
      }
    }
    return "Zmiana hasła";
  };

  return (
    <>
      <AdminSidebar
        {...props}
        routes={adminRoutes}
        logo={{
          innerLink: "/admin/index",
          imgSrc: require("../assets/img/brand/argon-react.png").default,
          imgAlt: "...",
        }}
      />
      <div className="main-content" ref={mainContent}>
        <AdminNavbar
          {...props}
          brandText={getBrandText(props.location.pathname)}
        />
        <Switch>
          {getRoutes(adminRoutes)}
          <AdminRoute
            path={"/admin/add-examination"}
            component={AddExamination}
            key={"/admin/add-examination"}
          />
          <AdminRoute
            path={"/admin/change-password"}
            component={ChangePassword}
            key={"/admin/change-password"}
          />
          <AdminRoute
            path={"/admin/edit-user"}
            component={EditUser}
            key={"/admin/edit-user"}
          />
          <Redirect from="*" to="/admin/users" />
        </Switch>
        <Container fluid>
          <AdminFooter />
        </Container>
      </div>
    </>
  );
};

export default Admin;
